import clsx from 'clsx';
import React, { FC } from 'react';
import { BaseProfileIcon } from '@td-client-frontend/icons';
import { MarketingProfile } from '../../../@types/Marketing';

interface ListboxProps {
  data?: MarketingProfile[];
  selectedItem: MarketingProfile | null;
  onSelectedItem(value: MarketingProfile): void;
}

export const Listbox: FC<ListboxProps> = ({ data = [], selectedItem, onSelectedItem }) => (
  <div className="border-1 border-gray-70 rounded-lg overflow-hidden">
    <div className="w-96 min-h-max max-h-96 border-gray-70 overflow-x-auto">
      <ul>
        {data.map((item) => {
          const isSelected = selectedItem ? selectedItem.id === item.id : false;
          return (
            <li
              className={clsx(
                'flex gap-3 items-center p-3 ml-1 h-12 cursor-pointer text-lg text-gray-65',
                isSelected ? 'font-bold border-blue-80 border-b-2' : 'border-b-1'
              )}
              aria-selected={isSelected}
              onClick={() => onSelectedItem(item)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onSelectedItem(item);
                }
              }}
              role="option"
              tabIndex={-1}
              key={item.id}
            >
              {item.default && <BaseProfileIcon width="16" height="16" />}
              {item.name}
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);
